/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 * 
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 * 
 * $Id: quicklinkteaser.js
 */
SCS.ensure(function(context, $) {
	context.find('.scs-quicklink-teaser-container').each(function() {
		var teaser = $(this);
		teaser.load(teaser.data('load-url'));
	});
}, 'body, .ui-tabs-panel, .displayRequest, .scs-accordion-tab-panel');



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/help/clientlibs/desktop/js/quicklinkteaser.js
// module id = 347
// module chunks = 0